import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getThemeSettingSlice = createSlice({
    name: 'ThemeSetting',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchThemeSetting.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchThemeSetting.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchThemeSetting.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setThemeSetting, setStatus } = getThemeSettingSlice.actions;
export default getThemeSettingSlice.reducer;

export const fetchThemeSetting = createAsyncThunk('/ThemeSettingget/fetch', async () => {
    const res = await axios.get(`${window.env.API_URL}/Themeget`);
    const ThemeSettingData = res.data;
    return ThemeSettingData.data;
})